// client/src/pages/Privacy.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold">Privacy Policy</h1>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="max-w-4xl mx-auto rounded-3xl bg-[#090912] border border-white/5 p-8 md:p-10 text-sm md:text-base text-gray-200 space-y-4 leading-relaxed"
      >
        <p>
          This policy explains how SMSOrbit uses and protects your personal
          information. We collect only the data required to operate your
          account, process payments and provide support.
        </p>
        <p>
          We do not sell, rent or trade your personal data to third parties. We
          may use trusted payment processors and infrastructure providers, but
          they only receive the minimum information needed to complete their
          tasks.
        </p>
        <p>
          By using SMSOrbit you agree to this policy. If you have questions,
          contact support before placing orders or adding funds.
        </p>
      </motion.div>
    </div>
  );
}
